import styled from 'styled-components';

export const ChannelItemWrapper = styled.div`
    padding: 0 10px;
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  cursor: pointer;
    &:nth-child(2n){
        background-color: #F4F4F5;
    }
`;

export const Icon = styled.img`
   width: 35px;
`;

export const Title = styled.span`
  font-size: 14px;
  line-height: 1.2;
  font-weight: 500;
  color: #1C1C1C;
  flex: 1;
    padding: 15px 0;
`;

export const Order = styled.span`
  font-size: 14px;
  line-height: 1.2;
  font-weight: 500; 
  color: #1C1C1C;
`;

export const NumberWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Number = styled.span`
  font-size: 14px;
  line-height: 1.2;
  font-weight: 500;
  color: #1C1C1C;
`;
